import React, { useState } from "react"
import I18n from "@helper/i18nInstance"
import onEnterOrSpace from "@helper/onEnterOrSpace"
import _ from "lodash"

import { useQuiz } from "@Quiz/context"
import Button from "@ui/Button"

export const SliderResultInfo: React.FC<{ question: Quiz.Api.SliderQuestion}> = () => {
  return null
}

const SliderAnswers: React.FC = () => {
  const { quiz, actions } = useQuiz()
  const [ selectedIndex, setSelectedIndex ] = useState<number>()

  if (!(quiz?.question?.config?.type === "slider")) { return null }
  const config = quiz.question.config as Quiz.Api.Slider.QuestionConfig

  const showSelectedLabelAboveSlider = _.isNumber(selectedIndex)

  return (
    <div className="neo__sliderAnswer">
      <div className="neo__sliderAnswer__sliderAndTexts">
        <div className="neo__sliderAnswer__sliderSelectedLabelAboveSlider">
          {showSelectedLabelAboveSlider && _.map(config.options, (o, index) => {
            const active = selectedIndex === index
            return (<div key={index} className={active ? "--active" : undefined}>
              {config.options[index].text}
            </div>)
          })}
        </div>
        <div className="neo__sliderAnswer__radiosHolder">
          <div className="neo__sliderAnswer__radios">
            {_.map(config.options, (option, index) => {
              const onSelect = () => setSelectedIndex(index)
              return (
                <div
                  key={index}
                  role="button"
                  tabIndex={0}
                  onClick={onSelect}
                  onKeyDown={onEnterOrSpace(onSelect)}
                  className={`neo__sliderAnswer__radio neo__sliderAnswer__radio--${selectedIndex === index ? "selected" : "notSelected"}`}>
                  <span className="neo__sliderAnswer__radio__button" />
                  <span className="neo__sliderAnswer__radio__number">{index + 1}</span>
                </div>
              )
            })}
          </div>
          <div className="neo__sliderAnswer__whatDoesWhatMean">
            {`(1 = ${config.options[0].text}, ${config.options.length} = ${config.options[config.options.length - 1].text})`}
          </div>
        </div>
      </div>
      <div className="neo__sliderAnswer__buttonHolder">
        <Button
          onClick={_.isNumber(selectedIndex) ? () => actions.answerQuestion({ type: "slider", picked_option: config.options[selectedIndex].val}) : undefined}>
          {I18n.t("quiz.question.slider.btn_send_answer")}
        </Button>
      </div>
    </div>
  )
}

export default SliderAnswers
